import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector, useIsLoggedSelector } from "../../../services/hooks.service";
import styleAf from "./Affiliate.module.scss";
import "./../../../index.scss";
import classNames from "classnames";
import { Col, Container, Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as COPY } from '../../../assets/images/icon_copy.svg';
import { ReactComponent as LINK } from '../../../assets/images/aff_link.svg';
import { ReactComponent as CAL } from '../../../assets/images/calendar_month.svg';
import { ReactComponent as CONGRAT } from '../../../assets/images/celebration.svg';
import { toast } from "react-toastify";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { AffiliateStats, AffiliateTime, affiliateTimeDropdowm, DBAffiliate } from "../../../interfaces";
import { AffiliateConnection } from "./AffiliateConnection";
import { AffiliateChart } from "./AffiliateChart";
import { AffDetails } from "./AffDetails";
import { MobileFooter } from "../../common/Footer/MobileFooter/MobileFooter";
import { ModalApp } from "../../common";
import { CongratsModal } from "./CongratsModal";
import { AffBolcks } from "./AffiliateBolcks";
import { errorHandler } from "../../../_utils/errorHandlers";
import { saveAffiliate, saveIsAffiliate } from "../../../redux/_actions/user.action";
import { MaintenanceBanners } from "../Exchange/Banners";
import { Loader } from "../../common/Loader/Loader";

const Affiliate = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isLogged = useIsLoggedSelector();
  const isAffiliate = useAppSelector((state) => state.user.isAffiliate);
  const affiliate = useAppSelector((state) => state.user.affiliateData);
  const sdkClient = useAppSelector((state) => state.sdkClient.instance);
  const companyId = useAppSelector((state) => state.settings.companyId);

  const [isLoading, setIsLoading] = useState(false);
  const [firstTimeModal, setFirstTimeModal] = useState(false);
  const [activeRange, setActiveRange] = useState(AffiliateTime.last_7_days);
  const [activeStat, setActiveStat] = useState<AffiliateStats>(AffiliateStats.totalRevenue);

  const getAffiliateInfo = async () => {
    try {
      if (!affiliate) setIsLoading(true);
      const aff = await sdkClient.getAffiliateInfo(companyId, activeRange);
      if (aff) dispatch(saveAffiliate(aff));
    } catch (e) {
      errorHandler(e);
    } finally {
      setIsLoading(false);
    }
   }

  const handleNewAffiliate = async () => {
    try {
      setIsLoading(true);
      const aff = await sdkClient.createAffiliate(companyId);
      if (aff) dispatch(saveAffiliate(aff));
      setFirstTimeModal(true);
      dispatch(saveIsAffiliate(true));
    } catch (e) {
      errorHandler(e);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (firstTimeModal) return;
    if (isAffiliate && companyId) getAffiliateInfo();
  }, [isAffiliate, companyId, activeRange])

  return (
    <Container fluid className={classNames("p-0", styleAf.layout)}>
      <MaintenanceBanners />
      <Col className={classNames(styleAf.wrapper, {[styleAf.wrapper_color]: !affiliate})}>
      { isLogged && (isAffiliate === null || isLoading)
        ? <Loader height={50} width={50} wrapperStyle={{ margin: "50px 48%" }} />
        : !isAffiliate
          ? <AffiliateConnection setAffiliate={handleNewAffiliate} />
          : <div>
              <h4>
                <div className={styleAf.header_link}>
                  <LINK />
                  <span className="text_gray">{ t("affiliates.invite_link") }</span>
                  <p className={styleAf.link_txt}>{affiliate?.referralLink?.split("?r=")[1]}</p>
                  <CopyToClipboard 
                    text={affiliate?.referralLink} 
                    onCopy={() => toast.success(t("success_msg.success_msg"), {className: "custom-toast"})}
                  >
                    <button> <COPY /> </button> 
                  </CopyToClipboard>
                </div>

                <div className={classNames(styleAf.header_link, styleAf.center_header_link)}>
                  <CAL />
                  <span className="text_gray">{ t("affiliates.view_by") }</span>
                  <Dropdown className={styleAf.dropdowm_cont}>
                    <span>{ t(affiliateTimeDropdowm[activeRange]) }</span>
                    <Dropdown.Toggle variant="success" className={styleAf.toggle}>
                      <i className="fa fa-angle-down" aria-hidden="true"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className={styleAf.dropdown_list}>
                      { Object.entries(affiliateTimeDropdowm).map(([v, text]) => (
                        <Dropdown.Item key={v} onClick={() => setActiveRange(v)}>
                          <span>{ t(text) }</span>
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </h4>

            <div className={styleAf.reff_body}>
              <AffBolcks
                feeShare={affiliate?.feeShare}
                summaryStats={affiliate?.summaryStats}
                activeStat={activeStat}
                setActiveStat={(b: AffiliateStats) => setActiveStat(b)}
              />

              <AffiliateChart 
                info={affiliate?.trendStats[activeStat]}
                activeStat={activeStat}
                activeRange={t(affiliateTimeDropdowm[activeRange])}
              />

              <AffDetails 
                details={affiliate?.trendStats} 
                filter={activeRange}
              />
            </div>
          </div>
      }
      </Col>

      <ModalApp 
        show={firstTimeModal} 
        width={540}
        onHide={() => setFirstTimeModal(false)}
        titleIcon={ <CONGRAT /> }
        title={t("affiliates.congratulations_referrals")}
      >
        <CongratsModal link={affiliate?.referralLink} onHide={() => setFirstTimeModal(false)} />
      </ModalApp>

      <MobileFooter />
    </Container>
  );
};

export default  Affiliate;
